export enum OrderEntryStatusEnum {
  PENDING = 'pending',
  SHIPPING = 'shipping',
  REJECTED = 'rejected',
  ACCEPTED = 'accepted'
}
